export const BANNER_HEIGHT = 0;
export async function showRewarded(onEarned, onFailed) { onEarned(); }
export async function showRewardedCoin(onEarned, onFailed) { onEarned(); }
export async function showInterstitial(onClosed) { onClosed(); }
export async function showBanner() {}
export async function hideBanner() {}
export function isBannerVisible() { return false; }
